/**
 * Ajax filtering for the Insights landing page
 */
(function (window, document, $, undefined) {
    "use strict";

    // variables
    window.chip = "none";
    window.asset = "none";
    window.theme = "none";
    window.format = "none";
    window.region = "none";
    window.lifeBusiness = "none";
    window.trust = "none";
    window.firstLoad = "true";
    window.url = new URL(window.location.origin + window.location.pathname);
    window.selectedQuery = {};
    window.params = window.location.search;
    window.select_ids = {};

    window.filterInsights = {
        init: function () {
            var chip = sessionStorage.getItem("chip");
            if (chip) {
                window.selectedQuery = chip;
                sessionStorage.removeItem("chip");
            }
            // first load rebuild query
            if (window.firstLoad === "true") {
                if (window.location.search !== "") {
                    var string = window.location.search
                        .substring(1)
                        .replace(new RegExp("=", "g"), ",")
                        .replace(new RegExp("&", "g"), ",")
                        .split(",");
                    var chipparam = $.inArray("chip", string);
                    if (chipparam !== -1) {
                        var num = ++chipparam;
                        $(".button_pills__item").removeClass("active");
                        $(".button_pills__item[data-slug='" + string[num] + "']").addClass(
                            "active"
                        );
                        Object.assign(window.selectedQuery, {
                            chip_tax_term: string[num],
                            chip_tax_tax: "jh_chip_categories",
                        });
                        window.chip = string[num];
                    }
                    var formatparam = $.inArray("format", string);
                    if (formatparam !== -1) {
                        var num = ++formatparam;
                        $("#filter_new_format option[value='" + string[num] + "']").attr(
                            "selected",
                            "selected"
                        );
                        Object.assign(window.selectedQuery, {
                            format_tax_term: string[num],
                            format_tax_tax: "jh_article_format",
                        });
                        window.format = string[num];
                        window.url.searchParams.append("format", string[num]);
                    }
                    var regionparam = $.inArray("region", string);
                    if (regionparam !== -1) {
                        var num = ++regionparam;
                        $("#filter_new_region option[value='" + string[num] + "']").attr(
                            "selected",
                            "selected"
                        );
                        Object.assign(window.selectedQuery, {
                            region_tax_term: string[num],
                            region_tax_tax: "article_region",
                        });
                        window.region = string[num];
                        window.url.searchParams.append("region", string[num]);
                    }
                    var trustparam = $.inArray("trust", string);
                    if (trustparam !== -1) {
                        var num = ++trustparam;
                        $("#filter_trusts option[value='" + string[num] + "']").attr(
                            "selected",
                            "selected"
                        );
                        Object.assign(window.selectedQuery, {
                            trust_tax_term: string[num],
                            trust_tax_tax: "article_trusts",
                        });
                        window.trust = string[num];
                        window.url.searchParams.append("trust", string[num]);
                    }
                } else {
                }
            }
            // filter selects for deep linking
            if (window.location.search !== "") {
                var string = window.location.search
                    .substring(1)
                    .replace(new RegExp("=", "g"), ",")
                    .replace(new RegExp("&", "g"), ",")
                    .split(",");
                var chipparam = $.inArray("chip", string);
                if (chipparam !== -1) {
                    var num = ++chipparam;
                    $(".button_pills__item").removeClass("active");
                    $(".button_pills__item[data-slug='" + string[num] + "']").addClass(
                        "active"
                    );
                }
                var regionparam = $.inArray("region", string);
                if (regionparam !== -1) {
                    var num = ++regionparam;
                    $("#filter_new_region option[value='" + string[num] + "']").attr(
                        "selected",
                        "selected"
                    );
                    $("#filter_new_region").prop("disabled", true);
                    $("#filter_new_region").css("cursor", "not-allowed");
                }
                var formatparam = $.inArray("format", string);
                if (formatparam !== -1) {
                    var num = ++formatparam;
                    $("#filter_new_format option[value='" + string[num] + "']").attr(
                        "selected",
                        "selected"
                    );
                    $("#filter_new_format").prop("disabled", true);
                    $("#filter_new_format").css("cursor", "not-allowed");
                }
                var trustparam = $.inArray("trust", string);
                if (trustparam !== -1) {
                    var num = ++trustparam;
                    $("#filter_trust option[value='" + string[num] + "']").attr(
                        "selected",
                        "selected"
                    );
                    $("#filter_trust").prop("disabled", true);
                    $("#filter_trust").css({
                        cursor: "not-allowed",
                        "text-overflow": "ellipsis",
                        "padding-right": "3em",
                    });
                }
            }

            // init required functions
            filterInsights.chipHandling();
            filterInsights.selectHandling();
            filterInsights.clearFiltersButton();
        },

        chipHandling: function () {
            $(".button_pills__item.all").on("click", function (ev) {
                ev.preventDefault();
                filterInsights.clearOptions();
                filterInsights.disableButtons();
                $(".button_pills__item").removeClass("active");
                $(this).addClass("active");
                window.firstLoad = "false";
                window.chip = "none";
                window.history.replaceState(
                    {},
                    "",
                    window.url.origin + window.url.pathname
                );
                filterInsights.ajaxPosts();
            });
            $(".button_pills__item.select").on("click", function (ev) {
                ev.preventDefault();
                $(".button_pills__item").removeClass("active");
                $(this).addClass("active");
                filterInsights.disableButtons();
                filterInsights.clearOptions();
                window.firstLoad = "false";
                window.chip = $(this).attr("value");
                Object.assign(window.selectedQuery, {
                    chip_tax_term: $(this).attr("value"),
                    chip_tax_tax: $(this).attr("data-tax"),
                });
                var chipURL = new URL(
                    window.url.origin +
                    window.url.pathname +
                    "?chip=" +
                    $(this).attr("value")
                );
                window.history.replaceState({}, "", chipURL);
                filterInsights.ajaxPosts();
            });
        },

        selectHandling: function () {
            // grab ids of the selects
            $(".insight_sub_filter").each(function () {
                window.select_ids[this.id] = this[1].dataset.argType;
            });

            // loop through the ids
            $.each(window.select_ids, function (key, val) {
                var item = "#" + key;
                $(item).change(function () {
                    $(this).attr("selected", "selected");
                    filterInsights.disableButtons();
                    window.firstLoad = "false";
                    var chosen = $(item + " option:selected");
                    var window_var = chosen.attr("value");
                    if (window.url.searchParams.has(chosen.attr("data-arg-type"))) {
                        window.url.searchParams.delete(chosen.attr("data-arg-type"));
                    }
                    window.url.searchParams.append(
                        chosen.attr("data-arg-type"),
                        chosen.attr("value")
                    );
                    var option = window.url["search"]
                        .substring(1)
                        .replace(new RegExp("=", "g"), ",")
                        .replace(new RegExp("&", "g"), ",")
                        .split(",");
                    var formatparam = $.inArray("format", option);
                    if (formatparam !== -1) {
                        if (window.format === "none") {
                            window.format = window_var;
                            Object.assign(window.selectedQuery, {
                                format_tax_term: window_var,
                                format_tax_tax: "jh_article_format",
                            });
                        }
                    }
                    var regionparam = $.inArray("region", option);
                    if (regionparam !== -1) {
                        if (window.region === "none") {
                            window.region = window_var;
                            Object.assign(window.selectedQuery, {
                                region_tax_term: window_var,
                                region_tax_tax: "article_region",
                            });
                        }
                    }
                    var trustparam = $.inArray("trust", option);
                    if (trustparam !== -1) {
                        if (window.trust === "none") {
                            window.trust = window_var;
                            Object.assign(window.selectedQuery, {
                                trust_tax_term: window_var,
                                trust_tax_tax: chosen.attr("data-tax-type"),
                            });
                        }
                    }
                    if (window.chip !== "none") {
                        var newParam = window.url["search"].substring(1);
                        var add_param_url =
                            window.location.origin +
                            window.location.pathname +
                            "?chip=" +
                            window.chip +
                            "&" +
                            newParam;
                        window.history.pushState({}, "", add_param_url);
                    } else {
                        var sub_filter_url =
                            window.location.origin +
                            window.location.pathname +
                            window.url.search;
                        window.history.pushState({}, "", sub_filter_url);
                    }
                    filterInsights.ajaxPosts();
                });
            });
        },

        ajaxPosts: function () {
            var size = Object.keys(window.selectedQuery).length;
            if (size === 0) {
                Object.assign(window.selectedQuery, {
                    empty: "empty",
                });
            } else {
                if (window.selectedQuery.empty) {
                    delete window.selectedQuery.empty;
                }
            }
            $.ajax({
                type: "GET",
                url: localized.ajax_url,
                dataType: "html",
                data: {
                    action: "trust_get_insights",
                    query: window.selectedQuery,
                    origin: window.location.pathname,
                },
                cache: false,
                complete: function (response) {
                    var jsonData = JSON.stringify(response.responseText);
                    if (jsonData.indexOf("Nothing Found") >= 0) {
                        filterInsights.ajaxPostsResults();
                    } else {
                        document.getElementById("trust-ajax-archive").innerHTML = response.responseText;
                        filterInsights.loadMoreCheck();
                        filterInsights.init();
                    }
                },
                error: function(xhr, status, error) {
                    console.log("Get Insights");
                    console.log("Error:", error);
                    console.log("Status:", status);
                    console.log("Response:", xhr.responseText);
                }
            });
        },

        ajaxPostsResults: function () {
            sessionStorage.setItem("reload", "no");
            window.location.reload();
        },

        disableButtons: function () {
            $(".button_pills__item").prop("disabled", true);
            $(".button_pills__item").css("cursor", "wait");
            $(".insight_sub_filter").prop("disabled", true);
            $(".insight_sub_filter").css("cursor", "wait");
            $(".insight_clear").css("cursor", "wait");
        },

        clearOptions: function () {
            window.asset = "none";
            window.theme = "none";
            window.format = "none";
            window.region = "none";
            window.lifeBusiness = "none";
            window.trust = "none";
            window.selectedQuery = {};
            $("#filter_new_asset_class option[value='default']").attr(
                "selected",
                "selected"
            );
            $("#filter_tags option[value='default']").attr("selected", "selected");
            $("#filter_new_format option[value='default']").attr(
                "selected",
                "selected"
            );
            $("#filter_new_region option[value='default']").attr(
                "selected",
                "selected"
            );
            $("#filter_life_business option[value='default']").attr(
                "selected",
                "selected"
            );
            $("#filter_trusts option[value='default']").attr("selected", "selected");
            window.url.searchParams.delete("asset");
            window.url.searchParams.delete("theme");
            window.url.searchParams.delete("format");
            window.url.searchParams.delete("region");
            window.url.searchParams.delete("lifeBusiness");
            window.url.searchParams.delete("trust");
        },

        clearFiltersButton: function () {
            $(".insight_clear#filter-reset").click(function () {
                window.firstLoad = "false";
                filterInsights.disableButtons();
                filterInsights.clearOptions();
                if (window.chip !== "none") {
                    var chipURL = new URL(
                        window.url.origin + window.url.pathname + "?chip=" + window.chip
                    );
                    Object.assign(window.selectedQuery, {
                        chip_tax_term: window.chip,
                        chip_tax_tax: "jh_chip_categories",
                    });
                    window.history.replaceState({}, "", chipURL);
                    filterInsights.ajaxPosts();
                } else {
                    window.history.replaceState(
                        {},
                        "",
                        window.url.origin + window.url.pathname
                    );
                    filterInsights.ajaxPosts();
                }
            });
        },

        loadMoreCheck: function () {
            var loadMore = document.getElementById("hidden_load_more").innerText;

            if (loadMore < 1) {
                $("#jh_load_more_insights").css("display", "none");
            } else {
                $("#jh_load_more_insights").css("display", "block");
            }
        },
    };

    filterInsights.init();


    ///////////////////////////////
    //// Insights Load More ///////
    ///////////////////////////////

    $("#jh_load_more_insights > a").click(function (e) {
        var $lm = $("#jh_load_more_insights");
        e.preventDefault();
        var lmPostArray = document.getElementsByClassName("insights-article-card");
        var lastPost = lmPostArray.length - 1;
        var currentPostCount = lmPostArray[lastPost].getAttribute('data-article_position');
        $.ajax({
            type: "GET",
            url: localized.ajax_url,
            dataType: "html",
            data: {
                action: "trusts_insights_loadmore",
                postCount: currentPostCount,
            },
            cache: false,
            success: function (response) {
                $("#insights_load_more").append(response);
                var lmArray = document.getElementsByClassName("hidden_load_more_ajax");
                var num = lmArray.length - 1;
                if (lmArray.length >= 1) {
                    var loadMore = lmArray[num].innerText;
                }
                if (loadMore < 1) {
                    $("#jh_load_more_insights").css("display", "none");
                }
            },
            error: function(xhr, status, error) {
                console.log("Load More");
                console.log("Error:", error);
                console.log("Status:", status);
                console.log("Response:", xhr.responseText);
            }
        });

        return false;
    });
})(window, document, jQuery);

// Calculate the height of each card's excerpt for desktop hover functionality.
document.addEventListener("DOMContentLoaded", function() {
    // Function to calculate and update the excerpt height.
    function updateInnerElementHeight() {
        // Check if the viewport width is greater than 1024px
        if (window.innerWidth > 1024) {
            const cards = document.querySelectorAll('.insights-article-card');
            if (cards) {
                cards.forEach(function(card) {
                    const excerptElement = card.querySelector('.insights-article-card__excerpt');
                    if (excerptElement) {
                        const excerptElementHeight = excerptElement.offsetHeight;
                        card.style.setProperty('--excerpt-height', excerptElementHeight + 'px');
                    }
                });
            }
        }
    }

    // Initial calculation on page load.
    updateInnerElementHeight();

    // Recalculate and update on browser resize.
    window.addEventListener('resize', function() {
        if (typeof debounce === 'function') {
            debounce(function () {
                // Only update when the viewport is wider than 1024px
                if (window.innerWidth > 1024) {
                    requestAnimationFrame(updateInnerElementHeight);
                }
            }, 250);
        }
    });
});
